// extracted by mini-css-extract-plugin
export default {"pureHeader":"pure-header_pureHeader__MLrqg"};